import { props } from '@ngrx/store';
import { createActionWithCorrelation } from '@kion/ngrx-helper';
import { Device, DeviceSearch, ReduxPagination } from '@kion/data-models';

export const searchSuccess = createActionWithCorrelation(
  '[Device] search success',
  props<{ searchResult: DeviceSearch }>()
);
export const searchError = createActionWithCorrelation(
  '[Device] search error',
  props<{ error: any }>()
);
export const search = createActionWithCorrelation(
  '[Device] search',
  props<{
    query?: string;
    sort: string;
    useState: boolean;
    useDefaultPage: boolean;
    mixedMode?: boolean;
  }>(),
  searchSuccess.type,
  searchError.type
);

export const loadByIdSuccess = createActionWithCorrelation(
  '[Device] load by id success',
  props<{ device: Device }>()
);
export const loadByIdError = createActionWithCorrelation(
  '[Device] load by id error',
  props<{ error: any }>()
);
export const loadById = createActionWithCorrelation(
  '[Device] load by id',
  props<{ factory: string; id: string }>(),
  loadByIdSuccess.type,
  loadByIdError.type
);

export const removeDevicesFromStoreSuccess = createActionWithCorrelation(
  '[Device] remove devices from store success',
  props<{ devices: Device[] }>()
);
export const removeDevicesFromStoreError = createActionWithCorrelation(
  '[Device] remove device from store error',
  props<{ error: any }>()
);
export const removeDevicesFromStore = createActionWithCorrelation(
  '[Device] remove device from store',
  props<{ devices: Device[] }>(),
  removeDevicesFromStoreSuccess.type,
  removeDevicesFromStoreError.type
);

export const updatePerPageSuccess = createActionWithCorrelation(
  '[Device] update perPage success',
  props<{ pagination: ReduxPagination }>()
);
export const updatePerPageError = createActionWithCorrelation(
  '[Device] update perPage error',
  props<{ error: any }>()
);
export const updatePerPage = createActionWithCorrelation(
  '[Device] update perPage',
  props<{ perPage: number }>(),
  updatePerPageSuccess.type,
  updatePerPageError.type
);

export const updatePageSuccess = createActionWithCorrelation(
  '[Device] update Page success',
  props<{ pagination: ReduxPagination }>()
);
export const updatePageError = createActionWithCorrelation(
  '[Device] update Page error',
  props<{ error: any }>()
);
export const updatePage = createActionWithCorrelation(
  '[Device] update Page',
  props<{ page: number }>(),
  updatePageSuccess.type,
  updatePageError.type
);

export const updateSortSuccess = createActionWithCorrelation(
  '[Device] update sort success',
  props<{ sort: string }>()
);
export const updateSortError = createActionWithCorrelation(
  '[Device] update sort error',
  props<{ error: any }>()
);
export const updateSort = createActionWithCorrelation(
  '[Device] update sort',
  props<{ sort: string }>(),
  updateSortSuccess.type,
  updateSortError.type
);
